import { useEffect, useState } from 'react';
import axiosConfig from '../config/axiosConfig';

export function useMonitorStream() {
  const [metrics, setMetrics] = useState({ cpu: 0, memory: 0, network: 0, storage: 0 });
  const [services, setServices] = useState([]);
  const [systemLogs, setSystemLogs] = useState([]);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const baseUrl = axiosConfig.defaults.baseURL || '';
    const streamUrl = `${baseUrl}/admin/stream`;

    const eventSource = new EventSource(streamUrl, {
      withCredentials: true 
    });

    eventSource.onopen = () => {
      console.log('[SSE] Connexion ouverte');
      setConnected(true);
    };

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data.type === 'metrics') {
          setMetrics(data.data);
        }

        if (data.type === 'services') {
          setServices(data.data);
        }

        if (data.type === 'log') {
          setSystemLogs(prev => [
            { ...data.data, timestamp: data.data.timestamp || new Date().toISOString() },
            ...prev.slice(0, 99)
          ]);
        }

        if (data.type === 'logs') {
          setSystemLogs(data.data);
        }

        if (data.type === 'heartbeat') {
          console.log('[SSE] Heartbeat');
        }
      } catch (err) {
        console.error('[SSE] Erreur parse:', err);
      }
    };

    eventSource.onerror = (err) => {
      console.error('[SSE] Erreur connexion:', err);
      setConnected(false);
    };

    return () => {
      eventSource.close();
      console.log('[SSE] Fermeture connexion');
    };
  }, []);

  return { metrics, services, systemLogs, connected };
}